import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

import withRouter from "components/Common/withRouter";

//Import Breadcrumb

import avatar from "../../assets/images/users/avatar-1.jpg";

import { editProfile, resetProfileFlag } from "slices/thunk";
import { createSelector } from 'reselect';
import jwt_decode from 'jwt-decode';
import CommonService from "services/CommonService";
import { ITokenModel } from "models/ITokenModel";
import { IUserModel } from "models/User.Model";
import { useNavigate, useParams } from "react-router-dom";
import { decryptOrderId, findedLocation, getCountryCodeStorage } from "../../helpers/Helper";
import INDCreateEdit from "pages/User/INDCreateEdit";
import UAECreateEdit from "pages/User/UAECreateEdit";
import CustomLoader from "components/Common/CustomLoader";
import { CustomButton } from "components/shared/CustomButton";
import PersonalDetailsServices from "services/PersonalDetails.Services";
import { HelperConstant } from "../../helpers/HelperConstant";


const UserProfile = () => {

  //meta title
  document.title = "Profile | DOFY Admin";

  const dispatch = useDispatch<any>();
  const id = useParams();
  const personId = id.id;
  const navigate = useNavigate();

  const [email, setemail] = useState("admin@gmail.com");
  const [detail, setDetail] = useState<IUserModel>();
  const [loading, setLoading] = useState(true);
  const [profileImage, setProfileImage] = useState<any>();
  const [name, setname] = useState(null);
  const [idx, setidx] = useState(1);
  const [editModal, setEditModal] = useState(0);
  const [dofyGeoList, setDofyGeoList] = useState<Array<any>>([]);
  const [stateList, setStateList] = useState<Array<any>>([]);
  const [filterLocation, setFilterLocationList] = useState<Array<any>>([]);
  const [roles, setRoles] = useState<Array<any>>([])

  const selectProperties = createSelector(
    (state: any) => state.Profile,
    (profile) => ({
      error: profile.error,
      success: profile.success
    })
  );

  const getMyAccount = (LoginId) => {
    CommonService.getWithSingleEntity('personModel', 'GetUser', LoginId).then((res) => {
      if (res.status === 200) {
        setDetail(res.data);
        setLoading(false);

      }
    }).catch(e => {
      if (e == 'Request failed with status code 401') {
      navigate('/logout')
    } else {
      console.error("API error:", e);
    }
    });
  }

  const riderProfilePage = () => {
    window.location.href = "/profile/" + detail?.Id;
  }

  // useEffect(() => {
  //   getMyAccount(personId);

  // }, [])

  useEffect(() => {
    getMyAccount(personId);

  }, [])

  const { error, success } = useSelector(selectProperties);

  // useEffect(() => {
  //   if (localStorage.getItem("authUser")) {
  //     const obj = localStorage.getItem("authUser" );
  //     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {

  //       setname(obj.displayName);
  //       setemail(obj.email);
  //       setidx(obj.uid);
  //     } else if (
  //       process.env.REACT_APP_DEFAULTAUTH === "fake" ||
  //       process.env.REACT_APP_DEFAULTAUTH === "jwt"
  //     ) {
  //       setname(obj.username || obj.providerData.displayName);
  //       setemail(obj.email || obj.providerData.email);
  //       setidx(obj.uid || obj.providerData.uid);
  //     }
  //     setTimeout(() => {
  //       dispatch(resetProfileFlag());
  //     }, 3000);
  //   }
  // }, [dispatch, success]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: name || 'admin',
      idx: idx || '',
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your UserName"),
    }),
    onSubmit: (values) => {
      dispatch(editProfile(values));
    }
  });

  const GetUserProfile = (userId) => {
    PersonalDetailsServices.GetBase64ProfileImage(userId).then((res: any) => {
      var base64ImageString: any = `data:image/png;base64,${res.data}`;
      setProfileImage(base64ImageString);
    }).catch(e => console.error(e))
  }

  const initialSelectedCityHandler = (data: Array<any>, value: string) => {
    const validLocation = value ? data.filter(it => it.Parent1 === parseInt(value)) : data;
    // var uniqueOptions = unique(validLocation, "Name");
    setFilterLocationList(validLocation);

  }

  const GetDOFYGeoList = () => {
    CommonService.getWithQueryParam("master", "GetAllDofyGeo", "serviceTypeId", HelperConstant.serviceTypeId.SELL).then((res) => {
      if (res.status === 200) {
        setDofyGeoList(res.data);
        initialSelectedCityHandler(res.data, '');
      }
    }).catch((e: string) => {
      console.log(e);
    });
  }

  const getStatesList = () => {
    CommonService.getWithQueryParam("master", "GetStateList", "serviceTypeId", HelperConstant.serviceTypeId.SELL).then(res => {
      if (res.status === 200) {
        setStateList(res.data)
      }
    }).catch(e => {
      console.log(e);
    });
  }

  const GetUserRole = () => {
    CommonService.get("master", "GetRoles").then(res => {
      if (res.status === 200) {
        setRoles(res.data);
      }
    }).catch(e => console.error(e))
  }

  useEffect(() => {
    GetUserProfile(personId);
    if(editModal){
    GetDOFYGeoList();
    getStatesList();
    GetUserRole()
    }

  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div>
            <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>PROFILE</h5>
          </div>
          <CustomLoader isOpen={loading} />
          <Row className="justify-content-center mt-lg-0">
            <Col xl={5} sm={8}>
              <Card style={{ borderTop: '6px outset #1E4496' }} className="p-0">
                <CardBody className="">
                  <Row className="justify-content-center">
                    <Col lg={10}>
                      <div className="text-center">
                        {profileImage ?
                          <img src={profileImage} alt="" height="60" className="mx-auto d-block rounded-3" />
                          :
                          <Row className="p-0 justify-content-center" style={{ borderRadius: '20px' }}>
                            <Col className="mb-0" xxl={2} xl={3} lg={3} md={3} sm={3} xs={3}>
                              <span className="avatar-title font-size-18 cursor-pointer rounded-3 border border-info" style={{ background: "#2a3042" }}>
                                <text className="mt-0 fw-bolder text-white fs-1">{detail?.FirstName.charAt(0).toUpperCase()}</text>
                              </span>
                            </Col>
                          </Row>}
                        <h5 className="mt-3 mb-1">{detail?.FirstName || ""}&nbsp;{detail?.LastName || ""}</h5>
                        <p className="text-muted mb-0">{roles.find(x => x.Id == detail?.UserRoleId)?.Name}</p>
                      </div>
                      <ul className="list-unstyled mt-4">
                        {detail?.AliasName !== "null" &&
                          <li>
                            <div className="d-flex mb-3">
                              <i className="bx bx-user-pin text-primary fs-4"></i>
                              <div className="ms-3">
                                <h6 className="fs-14 mb-2">Alias Name</h6>
                                <p className="text-muted fs-14 mb-0">{detail?.AliasName || ""}</p>
                              </div>
                            </div>
                          </li>}
                        <li>
                          <div className="d-flex">
                            <i className="bx bx-phone text-primary fs-4"></i>
                            <div className="ms-3">
                              <h6 className="fs-14 mb-2">Phone</h6>
                              <p className="text-muted fs-14 mb-0">{getCountryCodeStorage() == "in" ? "+91" : "+971"}  {detail?.Mobile || ""}</p>
                            </div>
                          </div>
                        </li>
                        <li className="mt-3">
                          <div className="d-flex">
                            <i className="bx bx-mail-send text-primary fs-4"></i>
                            <div className="ms-3">
                              <h6 className="fs-14 mb-2">Email</h6>
                              <p className="text-muted fs-14 mb-0">{detail?.Email || ''}</p>
                            </div>
                          </div>
                        </li>
                        {/* <li className="mt-3">
                          <div className="d-flex">
                            <i className="bx bx-map text-primary fs-4"></i>
                            <div className="ms-3">
                              <h6 className="fs-14 mb-2">Location</h6>
                              <p className="text-muted fs-14 mb-0">{detail?.Address},</p>
                              <p className="text-muted fs-14 mb-0">{filterLocation?.find(x => x?.Id == detail?.CityId)?.Name},</p>
                              <p className="text-muted fs-14 mb-0">{stateList?.find(x => x?.Id == detail?.StateId)?.Name} {detail?.PinCode == 'null' ? "" : ` - ${detail?.PinCode}`}</p>
                            </div>
                          </div>
                        </li> */}
                      </ul>
                      {HelperConstant.Roles.Rider != detail?.RoleId &&
                        <div className="mt-4" onClick={() => setEditModal(1)}>
                          <p className="btn btn-soft-primary btn-hover w-100 rounded">Edit Profile</p>
                        </div>}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal size='lg' isOpen={editModal > 0} toggle={() => setEditModal(0)} centered>
          <ModalHeader toggle={() => setEditModal(0)}>PROFILE EDIT</ModalHeader>
          <ModalBody>
            {findedLocation().CountryCode == "in" ?
              <INDCreateEdit id={editModal} setEditModal={setEditModal} userId={personId} />
              :
              <UAECreateEdit id={editModal} setEditModal={setEditModal} userId={personId} />
            }
          </ModalBody>
        </Modal>
      </div>

    </React.Fragment >
  );
};

export default withRouter(UserProfile);